import $ from 'jquery';

export default class WeixinSDKBridge {
  constructor() {
    this.sdkInited = false;
    this.tasks = [];
    this.getSignInfo();
  }

  getSignInfo() {
    $.ajax({
      url: 'https://api-data.da.mgtv.com/weixin/jssdk',
      data: {
        url: window.location.href.split('#')[0],
        rnd: Date.now() + Math.floor(Math.random() * 10),
      },
      dataType: 'json',
    }).done((resp) => {
      if (resp && resp.data) {
        const {
          appId, timestamp, nonceStr, signature,
        } = resp.data;
        const { wx } = window;
        wx.config({
          debug: window.location.search.indexOf('pfdebug=1') !== -1,
          appId, // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名，见附录1
          // 需要分享的列表项: 发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
          ],
        });
        wx.ready(() => {
          this.sdkInited = true;
          this.runExistTasks();
        });
      }
    });
  }

  runTask(func) {
    if (this.sdkInited) {
      func(window.wx);
    } else {
      this.tasks.push(func);
    }
  }

  runExistTasks() {
    if (this.tasks.length > 0) {
      const arr = this.tasks.concat();
      this.tasks = [];
      const { wx } = window;
      arr.forEach((func) => {
        try {
          return func(wx);
        } catch (error) {
          console.log(error);
        }
      });
    }
  }
}
